import Hero from './sections/Hero'
import SocialProof from './sections/SocialProof'
import Benefits from './sections/Benefits'
import ContactDemo from './sections/ContactDemo'

const HomePage = () => {
  return (
    <main>
      <Hero />
      <SocialProof />
      <Benefits />
      <ContactDemo />
    </main>
  )
}

export default HomePage
